import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertObligationAssessmentResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertObligationAssessmentResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface InsertObligationAssessmentResultInput {
  Rating: number;
  ObligationIds: string[];
  AssessmentId?: string | null;
  TestDate?: string | null;
  Rationale?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
}

export const useInsertObligationAssessmentResult = createMutationHook({
  name: 'insertObligationAssessmentResult',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.obligationAssessmentResult.insert.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: InsertObligationAssessmentResultInput) => input,
  // Invalidation parity with the legacy Apollo evictFields:
  // obligation_assessment_result (+ aggregate) and assessment.
  invalidate: (trpc) => [
    trpc.frontend.obligationAssessmentResult.pathKey(),
    trpc.frontend.assessment.pathKey(),
    // COI-889: the Obligations register's rating columns read the nested
    // `assessmentResults`.
    trpc.frontend.obligation.register.queryKey(),
  ],
  mapResponse: (result: {
    Ids: string[];
  }): InsertObligationAssessmentResultMutation => ({
    insertChildObligationAssessmentResult: {
      __typename: 'InsertChildObligationAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  graphqlDocument: InsertObligationAssessmentResultDocument,
  graphqlVariables: (input: InsertObligationAssessmentResultInput) => ({
    ...input,
  }),
  evictFields: [
    'obligation_assessment_result',
    'assessment',
    'obligation_assessment_result_aggregate',
  ],
});
